enum Environment {
  Development = "development",
  Production = "production",
}

const helpers = {
  [Environment.Development]: {
    api: "https://api-dev.elearninghumas.id/",
    metaBase: {
      siteUrl: process.env.NEXT_PUBLIC_METABASE_SITE_URL || "",
      secretKey: process.env.NEXT_PUBLIC_METABASE_SECRET_KEY || "",
    },
    loginKeycloakActive: process.env.NEXT_PUBLIC_KEYCLOAK_ACTIVE || 0,
  },
  [Environment.Production]: {
    api: "https://api.elearninghumas.id/",
    metaBase: {
      siteUrl: process.env.NEXT_PUBLIC_METABASE_SITE_URL || "",
      secretKey: process.env.NEXT_PUBLIC_METABASE_SECRET_KEY || "",
    },
    loginKeycloakActive: process.env.NEXT_PUBLIC_KEYCLOAK_ACTIVE || 0,
  },
};

export const getEnvironment = () => {
  const key =
    (process.env.NEXT_PUBLIC_ENVIRONMENT as Environment) || "development";
  return helpers[key];
};
